import { Component, Prop } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class LoyaltyTeirOverview extends ThemeComponent {
    @Prop customer!: boolean;

    init() {
        if(!this.customer) {
            return;
        }

        let timesRun = 0;

        const interval = setInterval(() => {
            const boxes: NodeListOf<HTMLElement>|[] = this.querySelectorAll('.lion-tier-box');
            timesRun += 1;

            if(timesRun === 4) {
                this.classList.add('visually-hidden');
                clearInterval(interval);
                return;
            }

            if(boxes.length) {
                this.process(boxes);
                clearInterval(interval);
            }

        }, 1000);
    }

    process(boxes:NodeListOf<HTMLElement>|[]) {
        if(!boxes.length) {
            return;
        }

        let currentIndex = 0;
        let currentBox = undefined;

        for(const [i, b] of boxes.entries()) {
            if(b.classList.contains('lion-tier-box--current')) {
                currentIndex = i;
                currentBox = b as HTMLElement;
                break;
            }
        }

        if(!currentBox) {
            return;
        }

        const subtitle = currentBox.querySelector('.lion-tier-box__sub-title') as HTMLElement;

        if(subtitle === undefined) {
            return;
        }

        subtitle.textContent = 'You are here';
        subtitle.style.display = 'block';

        const processBoxes = [...boxes as HTMLElement[]];
        const completedBoxes = processBoxes.slice(0, currentIndex);
        const lockedBoxes = processBoxes.slice(currentIndex + 1);


        if(completedBoxes.length) {
            for(const completedBox of completedBoxes) {
                const title = completedBox.querySelector('.lion-tier-box__title');
                const completedSubtitle = completedBox.querySelector('.lion-tier-box__sub-title');

                if(!completedSubtitle) {
                    return;
                }

                if(!title) {
                    return;
                }

                completedSubtitle.textContent = `You've completed ${title}`;
            }
        }

        if(lockedBoxes.length) {
            for(const lockedBox of lockedBoxes) {
                const lockedSubtitle = lockedBox.querySelector('.lion-tier-box__sub-title') as HTMLElement;

                if(!lockedSubtitle) {
                    return;
                }

                lockedSubtitle.style.display = 'block';
            }
        }

    }
}

